<script>
    import { onDestroy } from 'svelte';
    import { db, timeStamp, arrayUnion } from '../../firebase/firebase.config.js';

    // Custom Methods
    import currentMonth from '../../methods/currentMonth.js';
    
    // Custom Components
    import AddFunds from './AddFunds.svelte';
    import AddExpense from './AddExpense.svelte';

    // Stores
    import {UserStore, BankStore} from '../../store';

    // Props
    export let selectedTask;
    export let setSelectedTask;

    let uid;
    let currentTimeStamp;
    let collectionExists;
    let currentMnth = currentMonth();

    // Adds funds Variables
    let fundsAmount;
    let fundsProvider;
    let selectedBank;
    let fundsDate;


    // Stores
    const unsubUserStore = UserStore.subscribe(data => {
        uid = data.uid;
        collectionExists = data.dataExists;
    });

    

    // Life-cycle Hooks

    onDestroy(() => {
        unsubUserStore();
    });

</script>

<div id="addExpenseModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">

        {#if selectedTask === 'addExpense'}

            <AddExpense />

        {:else if selectedTask === 'addFunds'}

            <AddFunds />

        {:else}

            <div class="modal-content bg-light">

                <!-- Header -->
                <div class="modal-header border-0 pb-5">
                    <h5 class="modal-title text-secondary">Add Expense/Funds.</h5>
                    <button type="button" class="close text-dark" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Body -->
                <div class="modal-body row flex-column align-items-center py-5">

                    <div class="col-12 col-md-6">
                        <button class="btn btn-secondary btn-lg mb-4 w-100 py-4" on:click={() => setSelectedTask('addExpense')}>Add Expense</button>
                        <button class="btn btn-secondary btn-lg w-100 py-4" on:click={() => setSelectedTask('addFunds')}>Add Funds</button>
                    </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer border-0 pt-5">
                    <button type="button" class="btn btn-dark" data-dismiss="modal">Close</button>
                </div>
                
            </div>

        {/if}
    </div>
</div>